import { ComboOffer } from '../models/combo-offer.model';
import { Cart } from '../models/cart.model';

export class ComboOfferInitiation {
    protected comboModel: ComboOffer[];
    protected shopModel: Cart[];
    protected comboAmount: number = 0;
    constructor(combo?: ComboOffer[], shoppingCart?: Cart[]) {
        this.comboModel = combo;
        this.shopModel = shoppingCart;
    }
    hasCombo(): boolean {
        return this.shopModel.some(cart => this.comboModel.some(condition => condition.categoryId === cart.product.superCategoryId));
    }
    comboApply(): number {
      this.comboModel.forEach(condition => {
        this.comboAmount +=  this.checkOffer(condition)
        });
        return this.comboAmount;
    }
    protected checkOffer(condition: ComboOffer) {
        const appliedCart: Cart[] = this.shopModel.filter(cart => cart.product.superCategoryId === condition.categoryId);
        if (appliedCart.length === 0) return 0;
        const totalQty: number = appliedCart.reduce((total: number, cart: Cart) => total + cart.qty, 0);
        if (totalQty >= condition.minimumQty === false) return 0;
            const maximumOrder = (totalQty / condition.minimumQty) >> 0;
            let tempCount: number = 0;
            let balanceCount: number = 0;
            let isOver: boolean = false;
            const appliedPrice: number = appliedCart.reduce((total: number, cart: Cart) => {
                tempCount += cart.qty;
                if (isOver) return total;
                    if (tempCount >= maximumOrder * condition.minimumQty) {
                        isOver = true;
                        balanceCount = tempCount - (tempCount - (maximumOrder * condition.minimumQty));
                    }
                    return total + (isOver === false ? cart.product.price * cart.qty : cart.product.price * balanceCount);
            }, 0);
            return appliedPrice * condition.offerValue / 100 ;
    }
}